class QuickAdd extends HTMLElement {
    constructor() {
      super();
  
      // Get the title and selection container from the element's dataset and DOM.
      this.title = this.dataset.title;
      this.handle = this.dataset.handle;
      this.selectionContainer = this.querySelector('[swatch-list]');
  
      // If data hasn't been loaded yet, add a mouseover event listener to fetch data.
      if (!this.data) {
        this.addEventListener('mouseover', this.getProductData.bind(this), { once: true });
      }
    }
  
    async getProductData() {
      const url = `${Shopify.routes.root}products/${this.handle}.js`;
  
      // Fetch product data and store it in the element's data property.
      const response = await fetch(url);
      const data = await response.json();
      this.data = data;
  
      // Compile and render the swatches template.
      this.compileTemplate(data);
    }

    loadSwatchEvent() {
      const main_obj = this;
      const swatch_btns = this.selectionContainer.querySelectorAll('.js-select-color');
      
      // Add event listener to button swatches after rendered
      if(swatch_btns) {
        swatch_btns.forEach(btns => {
          btns.addEventListener('click', function() {
            const product = main_obj.data;
            const variants = product.variants;
            const variant_id = parseInt(this.dataset.id)
            const current_variant = variants.find(variant => variant.id === variant_id);
            const image_element = main_obj.closest('.item-card').querySelector('.item-card-img img') || main_obj.closest('.item-card').querySelector('.boost-pfs-filter-product-item-main-image');
            const compare_at_price = current_variant.compare_at_price;
            const price = current_variant.price;
            const priceContainer = main_obj.closest('.item-card').querySelector('.item-price')
            
            if(!current_variant) return;

            // Load variant image
            if(current_variant.featured_image) theme.Images.switchImage(current_variant.featured_image, image_element);

            var priceHtml = '',
                cartBtn = main_obj.closest('.item-card').querySelector('.js-cart-btn'),
                idInput = main_obj.closest('.item-card').querySelector('.card-item-id'),
                available = current_variant.available;

            // Toggle 'swatch-selected' class
            swatch_btns.forEach(btn => this === btn ? this.classList.add('swatch-selected') : btn.classList.remove('swatch-selected'));

            // Set data attribute for variant ID and variant input
            cartBtn.setAttribute('data-id', current_variant.id)
            idInput.value = current_variant.id

            // Change price
            if(compare_at_price && compare_at_price > price) {
              priceHtml = `<span class="text-sale">${theme.Currency.formatMoney(price, theme.moneyFormat).replace('PHP', '₱')}</span>
              <s class="ml-1 text-silver">${theme.Currency.formatMoney(compare_at_price, theme.moneyFormat).replace('PHP', '₱')}</s>`
            }else {
              priceHtml = `<span>${theme.Currency.formatMoney(price, theme.moneyFormat).replace('PHP', '₱')}</span>`
            }

            priceContainer.innerHTML = priceHtml;

            // Toggle disabling add to cart button
            if(!available) {
              cartBtn.classList.remove('bg-red-300');
              cartBtn.textContent = 'Out of stock';
              cartBtn.setAttribute('disabled', '');
            }else {
              cartBtn.classList.add('bg-red-300');
              cartBtn.textContent = 'Add to bag';
              cartBtn.removeAttribute('disabled');
            }
          })
        })
      }
    }
  
    compileTemplate(data) {
      if (!data) return;
  
      let swatchesHtml = '';
      const variants = data.variants;
  
      // If there are no swatches available, render a message.
      if (variants.length <= 0) {
        swatchesHtml = '<li><p>No Swatches available</p></li>';
      } else {
        // Compile a template for each variant.
        variants.forEach((variant) => {
          swatchesHtml += this.getListItemTemplate(data,variant);
        });
      }
  
      // Render the compiled swatches template.
      this.renderSwatches(swatchesHtml);
  
      // Remove the loading spinner and class from the selection container.
      const spinner = this.querySelector('.content-spinner-loader');
      if (spinner) spinner.remove();
      this.selectionContainer.classList.remove('on-loading');
    }
  
    renderSwatches(html) {
      if (!html) return;
  
      // Render the swatches HTML in the selection container.
      this.selectionContainer.innerHTML = html;
      this.loadSwatchEvent();
    }
  
    getListItemTemplate(product,variant) {
      if (!product || product.has_only_default_variant) return '';


      let listTemplates = '';
  
      const variants = product.variants;
      const color_handleize = this.handleize(variant?.title);
      const swatch = `${product.handle}-${color_handleize}_swatch`;
  
      // Compile a template for the given product and variant.
      if(variant) {
        listTemplates = `
            <li class="js-select-color swatch-option image"
                data-name="${product.title}"
                data-id="${variant?.id}"
                data-vendor="${product.vendor}"
                option-type="2"
                data-available="${variant?.available}"
                data-variant-id="${variant?.id}"
                data-variant-color="${variant?.title}"
                data-variant-image="${product.variant_img}"
                data-compare-at-price="${variant?.compare_at_price}"
                data-price="${variant?.price}">
            <div class="boost-pfs-product-item-tooltip">${variant?.title}</div>
            <span tabindex="0" aria-label="${variant?.title}" style="background-color: ${variant?.title}; background-image: url(${Utils.getFilePath(swatch, 'jpg', Date.now())});"></span>
            </li>
        `;
      }

      return listTemplates;
    }
    handleize(str) {
      if(!str) return;

      return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }
  }
  
  customElements.define('quick-add', QuickAdd);
  